// extracted by mini-css-extract-plugin
export default {"boonCheckbox":"Checkbox_boonCheckbox__zsNBC"};